import { SessionStore } from '../../constants';
import { Stage, Task } from '../../taskList/interfaces';

export const combineTasksAndProductList = (config: string): string => {
  const configuration = JSON.parse(config);
  const productList = JSON.parse(sessionStorage.getItem(SessionStore.basicTaskList) || '') || [];
  let tasks = configuration.configWidgetJSON.tasks;
  if (tasks?.length) {
    tasks = tasks.map((task: Task) => {
      const product = productList.find((product: Stage) => product.taskId === task.id);
      if (product) {
        task = {
          ...task,
          hurdleType: product?.hurdleType,
          stageId: product.id,
        };
      }

      return task;
    });
    configuration.configWidgetJSON.tasks = tasks;
    return JSON.stringify(configuration);
  }
  return config;
};
